export default "__VITE_ASSET__DOI6U5Us__"